export const getMenuItems = (canEditDelete: boolean) => [
  { key: "1", label: "Editar", disabled: !canEditDelete },
  { key: "2", label: "Excluir", disabled: !canEditDelete },
  // se tiver outros itens, mantém...
];

